import React, {useCallback} from 'react';
import ReactAutosizeTextArea from "react-textarea-autosize";
function TextArea({
                      rows,
                      value, onChange, autosize, placeholder,
maxLength,
}:{
    rows?: number, maxLength?: number,
    autosize?:boolean, value: string, onChange:(string)=>void, placeholder?: string}) {
    const changed = useCallback((e: {target:{value: string}})=>{
        onChange(e.target.value)
    },[onChange])
    if(autosize){
       return <ReactAutosizeTextArea
           rows={rows}
           maxLength={maxLength}
           placeholder={placeholder} className={'form-control'}
           value={value} onChange={changed} />
    }
    return (
        <textarea placeholder={placeholder} className={'form-control'}
                  rows={rows}
                  maxLength={maxLength}
                  onChange={changed} value={value}/>
    );
}

export default TextArea;
